import { c as _c } from "react/compiler-runtime";
import { I18n } from "@local/offer/src/lib/i18n";
import { currencySymbolFor } from "@local/offer/src/lib/const/marketsData";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { formatCurrency } from "@local/i18n/src/format";
import { priceSr } from "@local/i18n/src/catalogs/priceSr";
interface Props {
  value?: number | null;
  market?: string;
  /**
   * ISO code to render the value in, when it is not the browsing market's
   * currency (e.g. a past order in the account area, which is denominated in
   * whatever it was charged in). Omit and the market's symbol is used, which
   * is correct anywhere market and amount always agree.
   */
  currencyCode?: string;
  className?: string;
  noCurrencySymbol?: boolean;
  noConvertFromCent?: boolean;
  decimals?: number;
  /** Screen-reader-only label rendered before the value (e.g. "Original price"). */
  srLabel?: string;
}
export const Money = t0 => {
  const $ = _c(18);
  const {
    value,
    market,
    currencyCode,
    className,
    noCurrencySymbol,
    noConvertFromCent,
    decimals: t1,
    srLabel
  } = t0;
  const decimals = t1 === undefined ? 2 : t1;
  const resolvedMarket = market || "us";
  let isNegative;
  let srText;
  let t2;
  let t3;
  if ($[0] !== currencyCode || $[1] !== decimals || $[2] !== noConvertFromCent || $[3] !== noCurrencySymbol || $[4] !== resolvedMarket || $[5] !== srLabel || $[6] !== value) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        currencySymbol: marketSymbol,
        currencyCode: marketCurrencyCode
      } = I18n.getMarketData(resolvedMarket);
      const language = getLanguageForMarket(resolvedMarket);
      const currencySymbol = currencyCode ? currencySymbolFor(currencyCode) : marketSymbol;
      const effectiveCurrencyCode = currencyCode ?? marketCurrencyCode;
      const t = getT(language, {
        priceSr
      });
      const localizedSrLabel = srLabel ? t(`priceSr.${srLabel}` as Parameters<typeof t>[0]) : undefined;
      srText = localizedSrLabel && localizedSrLabel !== `priceSr.${srLabel}` ? localizedSrLabel : srLabel;
      if (value == null || isNaN(value)) {
        t3 = null;
        break bb0;
      }
      isNegative = value < 0;
      const absoluteValue = noConvertFromCent ? Math.abs(value) : Math.abs(value) / 100;
      t2 = formatCurrency(absoluteValue, effectiveCurrencyCode, language, {
        noSymbol: noCurrencySymbol,
        fractionDigits: decimals,
        symbol: currencySymbol,
        wordJoiner: true
      });
    }
    $[0] = currencyCode;
    $[1] = decimals;
    $[2] = noConvertFromCent;
    $[3] = noCurrencySymbol;
    $[4] = resolvedMarket;
    $[5] = srLabel;
    $[6] = value;
    $[7] = isNegative;
    $[8] = srText;
    $[9] = t2;
    $[10] = t3;
  } else {
    isNegative = $[7];
    srText = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const formatted = t2;
  let t4;
  if ($[11] !== srText) {
    t4 = srText ? <span className="sr-only">{srText} </span> : null;
    $[11] = srText;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = isNegative && "-";
  let t6;
  if ($[13] !== className || $[14] !== formatted || $[15] !== t4 || $[16] !== t5) {
    t6 = <span className={className}>{t4}{t5}{formatted}</span>;
    $[13] = className;
    $[14] = formatted;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};